var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-content"},[_c('div',{staticClass:"not-found-text"},[_c('h1',{staticClass:"not-found-title"},[_vm._v(" 404"),_c('font-awesome-icon',{attrs:{"icon":['far', 'frown']}})],1),_c('h2',[_vm._v("Page Not Found")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }